import { FC, useEffect, useState } from "react";
import {
  AccordionHeader,
  AccordionHeaderText,
  MuiBox,
  MuiDoubleLabel,
  MuiGrid,
} from "../../../../../components";

import { useSiteCore } from "../../../../../hooks/useSiteCore";

import { replaceHashWithValue } from "../../../../../helpers/utils";
import { Resource } from "../../../modelsAndSchemas/Models";
import { clientSpecificContentKeys } from "../../../siteCore/SiteCoreKeys";
import { useMediaQueries } from "../../../../../hooks/useMediaQueries";

interface ViewResourceProps {
  resources: Resource[];
}
export const ViewResource: FC<ViewResourceProps> = ({ resources }) => {
  const gridSize = { md: 4, sm: 6, xs: 12 };
  const [resourceAccordionStatus, setResourceAccordionStatus] = useState<
    boolean[]
  >([]);

  const { fetchLabel, fetchValueByKeyOfDropdown } = useSiteCore();
  const { isMobile } = useMediaQueries();
  const {
    clientSpecificContentTitle,
    resourceName,
    resourceID,
    resourceType,
    language,
    resourceHeading,
    resourceTypeList,
  } = clientSpecificContentKeys;

  const getLabel = (key: string) => {
    return fetchLabel(clientSpecificContentTitle, key);
  };

  const handleResourceAccordionStatus = (index: number, expanded: boolean) => {
    const status = [...resourceAccordionStatus];
    status[index] = expanded;
    setResourceAccordionStatus(status);
  };

  useEffect(() => {
    let status = [...resourceAccordionStatus];
    resources.forEach((_field, index) => {
      status[index] = true;
    });
    setResourceAccordionStatus(status);
  }, [resources.length]);

  const getResourceType = (resourceId: string) => {
    return fetchValueByKeyOfDropdown(
      clientSpecificContentTitle,
      resourceTypeList,
      resourceId,
    );
  };

  const renderHeader = (index: number) => {
    const label = replaceHashWithValue(
      getLabel(resourceHeading),
      `${index + 1}`,
    );
    return <AccordionHeaderText label={label} />;
  };

  return (
    <MuiBox data-testid="view-resource-tab">
      {resources.map((field, index) => (
        <AccordionHeader
          key={field.resourceId}
          title={renderHeader(index)}
          className="accordion-resource-header"
          onChange={(e, expanded) =>
            handleResourceAccordionStatus(index, expanded)
          }
          isExpanded={resourceAccordionStatus[index]}
        >
          <MuiGrid
            container
            columnSpacing={2}
            rowSpacing={isMobile ? 2 : 0}
            className="flex-row"
          >
            <MuiGrid size={gridSize}>
              <MuiDoubleLabel
                label={getLabel(resourceName)}
                value={field.resourceName}
              />
            </MuiGrid>

            <MuiGrid size={gridSize}>
              <MuiDoubleLabel
                label={getLabel(resourceType)}
                value={getResourceType(field.resourceTypeId)}
              />
            </MuiGrid>

            <MuiGrid size={gridSize}>
              <MuiDoubleLabel
                label={getLabel(resourceID)}
                value={field.resourceId}
              />
            </MuiGrid>

            <MuiGrid size={gridSize}>
              <MuiDoubleLabel
                label={getLabel(language)}
                value={field.languageId}
              />
            </MuiGrid>
          </MuiGrid>
        </AccordionHeader>
      ))}
    </MuiBox>
  );
};
